import * as React from "react";
import {Default} from "./Layouts/Desktop/Default";
import {Sidebar} from "./Layouts/Desktop/Sidebar";
import {Drilldown} from "./Layouts/Mobile/Drilldown";
import {Accordion} from "./Layouts/Mobile/Accordion";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import "./Megamenu.scss";

export const Megamenu = ({ settings, menuItems, id, state }) => {
    const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
    
    // Don't render if this megamenu isn't active
    if (state !== id) {
        return null;
    }


    // Select the appropriate layout based on device and settings
    const layout = isMobile ? settings.section.layout_mobile : settings.section.layout;
    
    // Handle the case where layout might not be defined
    const safeLayout = layout || (isMobile ? 'accordion' : 'default');
    
    // Ensure layout names are lowercase for consistent matching
    const normalizedLayout = safeLayout.toLowerCase();
    
    // Get the appropriate component based on the normalized layout name
    const LayoutComponent = Layouts[normalizedLayout] || Layouts.default;

    return (
        <LayoutComponent
            settings={settings}
            menuItems={menuItems}
            layout={normalizedLayout}
            id={id}
            state={state}
        />
    );
};

// Map of layout names to their respective components
const Layouts = {
    "default": Default,
    "sidebar": Sidebar,
    "drilldown": Drilldown,
    "accordion": Accordion,
};
